import {
  FETCH_CONFIGURATION_START,
  FETCH_CONFIGURATION_SUCCESS,
  FETCH_CONFIGURATION_ERROR,
  UPDATE_RATES_START,
  UPDATE_RATES_SUCCESS,
  UPDATE_RATES_ERROR,
} from "./configuration.types";

// Configuration actions
export const fetchConfigurationStart = () => ({
  type: FETCH_CONFIGURATION_START,
});
export const fetchConfigurationSuccess = (data) => ({
  type: FETCH_CONFIGURATION_SUCCESS,
  payload: data,
});
export const fetchConfigurationError = (error) => ({
  type: FETCH_CONFIGURATION_ERROR,
  payload: error,
});

export const updateRatesStart = (configuration, values) => ({
  type: UPDATE_RATES_START,
  payload: { configuration, values },
});

export const updateRatesSuccess = (data) => ({
  type: UPDATE_RATES_SUCCESS,
  payload: data,
});

export const updateRatesError = (error) => ({
  type: UPDATE_RATES_ERROR,
  payload: error,
});
